import { useSplitTreatments } from '@splitsoftware/splitio-react';

import { FeatureFlags } from '~constants/featureFlags';
import useSplitConfig from '~contexts/useSplitConfig';

interface UseFeatureFlagProps {
  featureFlagKey: FeatureFlags;
}

const useFeatureFlag = ({ featureFlagKey }: UseFeatureFlagProps) => {
  const { treatments, isReady } = useSplitTreatments({
    names: [featureFlagKey],
  });
  const featureFlag = treatments[featureFlagKey];

  return isReady && featureFlag.treatment === 'on';
};

const useAwaitableFeatureFlag = ({ featureFlagKey }: UseFeatureFlagProps) => {
  const { treatments, isReady, hasTimedout } = useSplitTreatments({
    names: [featureFlagKey],
  });
  const { isSplitConfigured } = useSplitConfig();
  const featureFlag = treatments[featureFlagKey];

  // isAwaitingTreatment differs from !isReady by also releasing on an SDK timeout or a
  // never-configured Split, which callers that redirect on the treatment need and
  // callers that only render a spinner do not.
  return {
    isAwaitingTreatment: isSplitConfigured && !isReady && !hasTimedout,
    isFeatureFlagEnabled: featureFlag.treatment === 'on',
    isReady,
  };
};

export { useAwaitableFeatureFlag, useFeatureFlag };
